import { render, staticRenderFns } from "./BecomeATeacherForm.vue?vue&type=template&id=78f26cb6&"
import script from "./BecomeATeacherForm.vue?vue&type=script&lang=js&"
export * from "./BecomeATeacherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports